<template>
  <div class="contract-modal">
    <HMModalHeader
      :title="$t('CONTRACTS.TITLES.NEW_TEMPLATE')"
      @close="$emit('close')"
    />
    <div v-if="!templateType" class="d-flex flex-row flex-nowrap">
      <section class="selection-card mr-2" @click="templateType = 'type'">
        <i class="fal fa-paste fa-2x c-brand-color"></i>
        <h4 class="mt-3">
          {{ $t('CONTRACTS.TEXT.PASTE_OR_TYPE_YOUR_TEMPLATE_CONTENT') }}
        </h4>
      </section>
      <section class="selection-card ml-2" @click="templateType = 'upload'">
        <i class="fal fa-file-pdf fa-2x c-brand-color"></i>
        <h4 class="mt-3">
          {{ $t('CONTRACTS.TEXT.UPLOAD_YOUR_TEMPLATE_PDF') }}
        </h4>
      </section>
    </div>
    <ValidationObserver v-else ref="form" v-slot="formData">
      <form @submit.prevent="createContract">
        <HMTextInput
          type="text"
          rules="required"
          :label="$t('CONTRACTS.LABELS.TITLE')"
          v-model="form.title"
          name="name"
        />
        <HMVueEditor
          v-if="templateType === 'type'"
          id="hm-vue-contract-template-editor"
          class="w-100"
          v-model="form.content"
          placeholder="Your contract template content"
        />
        <HMFileUpload
          v-else
          class="w-100"
          v-model="form.document"
          accept="application/pdf"
        />
        <HMVueEditor
          id="hm-vue-contract-template-editor-signature-paragraph"
          class="w-100 mt-4"
          v-model="form.signature_paragraph"
          placeholder="Optional paragraph that will be added above the signatures"
        />
        <HMTextInput
          class="mt-4"
          type="text"
          rules="required"
          :label="$t('CONTRACTS.LABELS.YOUR_FULL_NAME')"
          v-model="form.signature_full_name"
          name="name"
        />
        <div
          class="mt-4 d-flex flex-row flex-nowrap justify-content-between align-items-center"
        >
          <span>{{ $t('CONTRACTS.LABELS.SIGNATURE') }}</span>
          <HMButton @click="clearSignature">
            <span class="c-brand-color">{{ $t('GENERAL.BUTTON.CLEAR') }}</span>
          </HMButton>
        </div>
        <div class="signature-container mt-2">
          <VueSignaturePad width="100%" height="200px" ref="signaturePad" />
        </div>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('GENERAL.BUTTON.SAVE')"
          :disabled="formData.invalid"
          :formError="formError"
          @close="$emit('close')"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import { ValidationObserver } from 'vee-validate';
import { get } from 'lodash';
import { errorToMessage } from '@/core/utils/errors';
import HMVueEditor from '@/web/components/common/HMVueEditor';
import HMFileUpload from '@/web/components/common/HMFileUpload';
import { formatObjectForBackend } from '@/core/api/utils/converter';

export default Vue.extend({
  name: 'NewContractTemplateModal',
  components: {
    HMFileUpload,
    ValidationObserver,
    HMVueEditor,
  },
  props: {},
  data() {
    return {
      templateType: '',
      includeOwnSignature: false,
      includeSignatureParagraph: false,
      form: {
        title: '',
        document: null,
        full_name: null,
        content: null,
        signature: null,
        signature_paragraph: null,
      },
      formError: null,
    };
  },
  computed: {},
  methods: {
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty, data);
    },
    async createContract() {
      const signature = this.$refs.signaturePad.saveSignature();
      console.log(signature);
      if (!signature.isEmpty) {
        this.form.signature = signature.data;
      }
      try {
        const data = _.cloneDeep(this.form);

        const contract = await this.$store.dispatch(
          'contracts/createContract',
          formatObjectForBackend(data)
        );
        this.$emit('close');
        this.$parent.$emit('onContractTemplateCreated', contract);
      } catch (error) {
        this.formError = get(error, 'response.data.non_field_errors[0]', null);
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(
            error.response,
            'Failed to create new contract template'
          ),
          duration: -1,
        });
      }
    },
  },
  mounted() {
    this.form.signature_paragraph = this.$t(
      'CONTRACTS.TEXT.DEFAULT_SIGNATURE_PARAGRAPH'
    );
  },
  watch: {
    includeOwnSignature: {
      handler: function (value) {
        // workaround to make the signature appear, otherwise it's just blank when drawing
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 100);
      },
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.selection-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 2rem;
  border: 1px solid $light-gray;
  max-width: 50%;
  text-align: center;
  cursor: pointer;
  border-radius: $border-radius;
  &:hover {
    background-color: darken(white, 3%);
  }
}

.signature-container {
  border: 1px dashed $dark-gray;
  border-radius: $border-radius;
}
</style>
